import { ArcGisService } from './service';

export const ARC_GIS_QUERY_KEYS = {
  GET_COUNTIES_BY_STATE: 'GET_COUNTIES_BY_STATE',
};

export class ArcGisQueries {
  public static readonly getCountyListByState = async (stateName: string): Promise<string[]> => {
    return ArcGisService.getCountyListByState(stateName);
  };
}
